import OrganizationListItem from './OrganizationListItem'
import { Organization } from "@/types";

interface OrganizationsListProps {
    organizations: Organization[]
}

export default function OrganizationsList({organizations}: OrganizationsListProps) {
    return (
        <div className="bg-white shadow overflow-hidden sm:rounded-md">
            <div className="px-4 py-5 sm:px-6">
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                    All Organizations
                </h3>
                <p className="mt-1 max-w-2xl text-sm text-gray-500">
                    Overview of all tenant organizations in the system.
                </p>
            </div>
            <ul className="divide-y divide-gray-200">
                {organizations.map((org) => (
                    <OrganizationListItem key={org.id} organization={org}/>
                ))}
            </ul>
        </div>
    )
}